import { usePermissions } from '@/lib/hooks/use-permissions';
import { Permission } from '@/lib/api/interfaces/permissions.interface';

/**
 * Hook to check permissions specific to the template editor context.
 * Centralizes common permission checks used across the editor components.
 */
export const useTemplatePermissions = () => {
  const { can } = usePermissions();

  /**
   * Checks if the user has permission to edit the current template.
   * Grants access if user has either MANAGE_TEMPLATE_STORE (Store Templates) 
   * or MANAGE_CUSTOMER_TEMPLATE (Customer Templates) permissions.
   */
  const canEditTemplate = can(Permission.MANAGE_TEMPLATE_STORE) || can(Permission.MANAGE_CUSTOMER_TEMPLATE);

  /**
   * Checks if the user has permission to manage store templates specifically.
   * Required for advanced features like Overrides.
   */
  const canManageStore = can(Permission.MANAGE_TEMPLATE_STORE);

  /**
   * Checks if the user has permission to add watermarks.
   * Required for creating new watermarks or duplicating existing ones.
   */
  const canAddWatermarks = can(Permission.ADD_WATERMARKS);

  /**
   * Checks if the user has permission to edit (remove) watermarks.
   * Required for removing existing watermarks.
   */
  const canEditWatermarks = can(Permission.EDIT_WATERMARKS);

  return {
    canEditTemplate,
    canManageStore,
    canAddWatermarks,
    canEditWatermarks
  };
};
